import { footerColumns } from '@/mocks/home';

function SiteFooter() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-shell mx-auto px-4 md:px-8 pt-14 md:pt-20 pb-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-bold">
                爆
              </span>
              <span className="font-heading text-xl font-bold text-background-50">网红爆料</span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-background-300 max-w-sm">
              深耕网红圈爆料内容，围绕行业黑幕、签约内幕与公司压榨持续追踪，
              把零散线索整理成可核对的时间线，让每一条私聊记录都有出处。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-background-400 max-w-sm">
              如果你正在找某条网红爆料内幕的来龙去脉，可以从热度榜或深挖专区开始。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <span className="px-3 py-1.5 rounded-full bg-background-800 text-xs text-background-200">
                每日更新
              </span>
              <span className="px-3 py-1.5 rounded-full bg-background-800 text-xs text-background-200">
                线索核实
              </span>
              <span className="px-3 py-1.5 rounded-full bg-background-800 text-xs text-background-200">
                匿名保护
              </span>
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title} className="lg:col-span-2">
              <h4 className="text-background-50 font-heading text-base font-semibold mb-4">
                {column.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {column.links.map((item) => (
                  <li key={item}>
                    <a
                      href="#top"
                      className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-2">
            <h4 className="text-background-50 font-heading text-base font-semibold mb-4">
              线索通道
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              支持图文、视频与私聊截图投稿，全程匿名处理。
            </p>
            <a
              href="#submit"
              className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-md bg-accent-500 text-foreground-950 text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-contacts-book-2-line"></i>
              前往爆料
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-800">
          <p className="text-xs leading-relaxed text-background-400">
            免责声明：本站内容为基于公开线索归纳整理的信息展示，所涉人物、机构均以模糊代称呈现，
            相关描述不构成对任何具体主体的定性结论。如内容存在异议，可通过页面底部的更正与申诉渠道联系我们。
          </p>
          <div className="mt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              © 2026 网红爆料 · 内容仅供浏览参考
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#top"
                className="text-xs text-background-400 hover:text-background-100 transition-colors cursor-pointer"
              >
                隐私政策
              </a>
              <a
                href="#top"
                className="text-xs text-background-400 hover:text-background-100 transition-colors cursor-pointer"
              >
                使用条款
              </a>
              <a
                href="#top"
                className="text-xs text-background-400 hover:text-background-100 transition-colors cursor-pointer"
              >
                站点地图
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;